<template>
    <div>
        <div class="div100">
            <div class="select-drop">
                <select v-model="childDay" v-on:change="updateChildAge">
                    <option value="" disabled selected>Dag</option>
                    <option
                        v-for="(day, index) in createDays"
                        :value="day.number"
                        :key="'childDay' + index"
                    >
                        {{ day.name }}
                    </option>
                </select>
            </div>

            <div class="select-drop">
                <select v-model="childMonth" v-on:change="updateChildAge">
                    <option value="" disabled selected>Maand</option>
                    <option
                        v-for="(month, index) in createMonths"
                        :value="month.number"
                        :key="'childMonth' + index"
                    >
                        {{ month.name }}
                    </option>
                </select>
            </div>

            <div class="select-drop">
                <select v-model="childYear" v-on:change="updateChildAge">
                    <option value="" disabled selected>Geboortejaar</option>
                    <option
                        v-for="(year, index) in createYears"
                        :value="year"
                        :key="'childYear' + index"
                    >
                        {{ year }}
                    </option>
                </select>
            </div>
        </div>
        <div v-if="age">Kind is {{ age }} jaar oud op vertrekdatum cruise.</div>
    </div>
</template>

<script>
export default {
    name: 'CabinSetupItemSelect',
    props: {
        cabinIndex: Number,
        childIndex: Number,
    },
    data: function() {
        return {
            childDay: 1,
            childMonth: 1,
            childYear: null,
            age: null,
        }
    },

    computed: {
        createYears: function() {
            let currentYear = this.moment().year()
            let retYears = []

            let maxDisplayAge = 17

            for (let age = 0; age <= maxDisplayAge; age++) {
                retYears.push(currentYear - parseInt(age))
            }
            return retYears
        },
        createMonths: function() {
            let retMonths = []

            for (let month = 1; month <= 12; month++) {
                retMonths.push({
                    number: month,
                    name: this.moment()
                        .month(month - 1)
                        .format('MMMM'),
                })
            }
            return retMonths
        },
        createDays: function() {
            let retDays = []

            for (let day = 1; day <= 31; day++) {
                retDays.push({ number: day, name: day })
            }
            return retDays
        },

        departureDateCruise: function() {
            return this.$store.state.cruise.begindatum + 'T00:00:00'
        },

        /* childAge: {
            get: function() {
                return this.$store.state.cabinSetup[this.cabinIndex]
                    .kindLeeftijden[this.childIndex]
            },
            set: function(newVal) {
                this.$store.commit('changeCabinSetup', {
                    cabinSetupIndex: this.cabinIndex,
                    childIndex: this.childIndex,
                    childAge: newVal,
                })
            },
        }, */
    },
    methods: {
        updateChildAge: function() {
            if (
                this.childDay &&
                this.childMonth &&
                this.childYear &&
                this.departureDateCruise
            ) {
                let departureDate = this.moment(this.departureDateCruise)

                let birthday = this.moment()
                birthday
                    .year(this.childYear)
                    .month(this.childMonth - 1)
                    .date(this.childDay)
                if (birthday.isValid() && departureDate.isValid()) {
                    let birthdayShort = birthday.format('DD-MM-YYYY')
                    this.age = departureDate.diff(birthday, 'years')
                    this.$store.commit('changeCabinSetup', {
                        cabinSetupIndex: this.cabinIndex,
                        childIndex: this.childIndex,
                        childAge: this.age,
                        childBirthday: birthdayShort,
                    })
                }
            }
        },
    },
    mounted: function() {
        this.childYear = this.moment().year()
    },
}
</script>

<style scoped>
.div100 {
    width: 100% !important;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
}
.div100 .select-drop {
    margin: 5px;
    float: left;
    display: inline-block;
    max-width: 30%;
}
</style>
